/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type EnumTelehealthStatus = "created" | "ended" | "inProgress" | "noShow" | "scheduled" | "%future added value";
export type sagaWatchersTelehealthQueryVariables = {
    id: string;
};
export type sagaWatchersTelehealthQueryResponse = {
    readonly appointmentById: {
        readonly telehealth: {
            readonly patientWaitingSince: unknown | null;
            readonly status: EnumTelehealthStatus | null;
            readonly duration: number | null;
            readonly sessionDetails: {
                readonly readiness: {
                    readonly camera: boolean | null;
                    readonly microphone: boolean | null;
                    readonly browser: boolean | null;
                } | null;
            } | null;
        } | null;
    } | null;
};
export type sagaWatchersTelehealthQuery = {
    readonly response: sagaWatchersTelehealthQueryResponse;
    readonly variables: sagaWatchersTelehealthQueryVariables;
};



/*
query sagaWatchersTelehealthQuery(
  $id: MongoID!
) {
  appointmentById(_id: $id) {
    telehealth {
      patientWaitingSince
      status
      duration
      sessionDetails {
        readiness {
          camera
          microphone
          browser
        }
      }
      id
    }
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "_id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "patientWaitingSince",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "duration",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "TelehealthSessionDetails",
  "kind": "LinkedField",
  "name": "sessionDetails",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TelehealthSessionDetailsReadiness",
      "kind": "LinkedField",
      "name": "readiness",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "camera",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "microphone",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "browser",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "sagaWatchersTelehealthQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Appointment",
        "kind": "LinkedField",
        "name": "appointmentById",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Telehealth",
            "kind": "LinkedField",
            "name": "telehealth",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "sagaWatchersTelehealthQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Appointment",
        "kind": "LinkedField",
        "name": "appointmentById",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Telehealth",
            "kind": "LinkedField",
            "name": "telehealth",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "bea76cbd1354c4e8d3127452ee925a6e",
    "id": null,
    "metadata": {},
    "name": "sagaWatchersTelehealthQuery",
    "operationKind": "query",
    "text": "query sagaWatchersTelehealthQuery(\n  $id: MongoID!\n) {\n  appointmentById(_id: $id) {\n    telehealth {\n      patientWaitingSince\n      status\n      duration\n      sessionDetails {\n        readiness {\n          camera\n          microphone\n          browser\n        }\n      }\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();
(node as any).hash = 'df80fc6a26a084faf8d164be6984eb3d';
export default node;
